import * as XLSX from 'xlsx';
import { getSocieteInfos } from "./exportUtils";
import { formatCurrencyForExport, formatNumberForExport } from "./exportFormatters";

/**
 * Exporte les données CA vers Excel
 */
export const exportCAtoExcel = (data, selectedYear) => {
  try {
    const societe = getSocieteInfos();
    const wb = XLSX.utils.book_new();
    const wsData = [];
    
    const mois = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 
                  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    
    // En-tête du document
    wsData.push([`RAPPORT CHIFFRE D'AFFAIRES ${selectedYear}`]);
    wsData.push([societe.nom]);
    wsData.push([societe.adresse]);
    wsData.push([`Tél: ${societe.telephone} | Email: ${societe.email}`]);
    wsData.push([]);
    wsData.push([`Période: Année ${selectedYear}`]);
    wsData.push([]);
    
    // ✅ RÉSUMÉ DES TOTAUX
    wsData.push(['RÉSUMÉ GÉNÉRAL']);
    wsData.push(['Indicateur', 'Valeur']);
    wsData.push(['CA Annuel', formatCurrencyForExport(data.totaux?.ca_annuel || 0) + ' FCFA']);
    wsData.push(['CA Mensuel', formatCurrencyForExport(data.totaux?.ca_mensuel || 0) + ' FCFA']);
    wsData.push(['Nombre de clients', formatNumberForExport(data.totaux?.nb_clients || 0)]);
    wsData.push(['Nombre de fournisseurs', formatNumberForExport(data.totaux?.nb_fournisseurs || 0)]);
    wsData.push(['Nombre de produits', formatNumberForExport(data.totaux?.nb_produits || 0)]);
    wsData.push(['Créances totales', formatCurrencyForExport(data.totaux?.creances_total || 0) + ' FCFA']);
    wsData.push([]);
    wsData.push([]);
    
    // ✅ TABLEAU MENSUEL
    wsData.push(['ÉVOLUTION MENSUELLE DU CHIFFRE D\'AFFAIRES']);
    wsData.push(['Mois', 'CA (FCFA)']);
    
    if (data.ca_mensuel && data.ca_mensuel.length > 0) {
      data.ca_mensuel.forEach((montant, index) => {
        if (montant > 0) { // N'afficher que les mois avec des données
          wsData.push([
            mois[index],
            formatCurrencyForExport(montant) + ' FCFA'
          ]);
        }
      });
    }
    
    wsData.push([]);
    wsData.push([]);
    
    // ✅ TOP PRODUITS
    if (data.top_produits && data.top_produits.length > 0) {
      wsData.push(['TOP PRODUITS']);
      wsData.push(['Référence', 'Désignation', 'Quantité vendue', 'Montant total']);
      
      data.top_produits.forEach(produit => {
        wsData.push([
          produit.reference || '-',
          produit.designation || '-',
          formatNumberForExport(parseInt(produit.quantite_vendue) || 0),
          formatCurrencyForExport(parseFloat(produit.montant_total) || 0) + ' FCFA'
        ]);
      });
      
      wsData.push([]);
      wsData.push([]);
    }
    
    // ✅ TOP CLIENTS
    if (data.top_clients && data.top_clients.length > 0) {
      wsData.push(['TOP CLIENTS']);
      wsData.push(['Code client', 'Raison sociale', 'Nombre de factures', 'Total achats']);
      
      data.top_clients.forEach(client => {
        wsData.push([
          client.code_client || '-',
          client.raison_sociale || '-',
          formatNumberForExport(client.nb_factures || 0),
          formatCurrencyForExport(parseFloat(client.total_achats) || 0) + ' FCFA'
        ]);
      });
      
      wsData.push([]);
      wsData.push([]);
    }
    
    // ✅ VENTES PAR CATÉGORIE
    if (data.ventes_categories && data.ventes_categories.length > 0) {
      wsData.push(['VENTES PAR CATÉGORIE']);
      wsData.push(['Catégorie', 'Montant total']);
      
      data.ventes_categories.forEach(cat => {
        wsData.push([
          cat.nom_categorie || 'Sans catégorie',
          formatCurrencyForExport(parseFloat(cat.montant_total) || 0) + ' FCFA'
        ]);
      });
      
      wsData.push([]);
      wsData.push([]);
    }
    
    // ✅ REVENUS VS DÉPENSES
    if (data.income_expenses && data.income_expenses.length > 0) {
      wsData.push(['REVENUS VS DÉPENSES']);
      wsData.push(['Période', 'Revenus', 'Dépenses', 'Bénéfice']);
      
      data.income_expenses.forEach(item => {
        const revenus = parseFloat(item.revenus) || 0;
        const depenses = parseFloat(item.depenses) || 0;
        const benefice = revenus - depenses;
        
        wsData.push([
          item.mois || '-',
          formatCurrencyForExport(revenus) + ' FCFA',
          formatCurrencyForExport(depenses) + ' FCFA',
          formatCurrencyForExport(benefice) + ' FCFA'
        ]);
      });
    }
    
    // Créer la feuille
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    
    // Ajuster la largeur des colonnes
    ws['!cols'] = [
      { wch: 25 },  // Première colonne plus large
      { wch: 20 },  // Deuxième colonne
      { wch: 15 },  // Troisième colonne
      { wch: 15 }   // Quatrième colonne
    ];
    
    XLSX.utils.book_append_sheet(wb, ws, "Rapport financier");
    
    const fileName = `Rapport_financier_${selectedYear}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    
    return true;
  } catch (error) {
    console.error("Erreur export Excel:", error);
    alert("Erreur lors de l'export Excel: " + error.message);
    return false;
  }
};